import axios from 'axios'

const HTTP = axios.create({
  baseURL: 'http://api.tardiness.kmrcsm.ru/'
})

export default HTTP
